/* ============================================
   <sticky-scroll> Web Component
   IntersectionObserver-based image crossfade
   Budget: < 1KB uncompressed
   ============================================ */

class StickyScroll extends HTMLElement {
  connectedCallback() {
    /* Respect reduced motion */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /* Desktop only — CSS handles mobile sequential layout */
    if (window.innerWidth < 990) return;

    this.steps = this.querySelectorAll('[data-step]');
    this.images = this.querySelectorAll('[data-step-image]');

    if (this.steps.length === 0 || this.images.length === 0) return;

    var self = this;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            self.activateStep(entry.target.dataset.step);
          }
        });
      },
      {
        rootMargin: '-40% 0px -40% 0px',
        threshold: 0,
      }
    );

    this.steps.forEach(function (step) {
      observer.observe(step);
    });
  }

  activateStep(index) {
    this.images.forEach(function (img) {
      img.classList.toggle(
        'product-how-it-works__image-wrap--active',
        img.dataset.stepImage === index
      );
    });
    this.steps.forEach(function (step) {
      step.classList.toggle(
        'product-how-it-works__step--active',
        step.dataset.step === index
      );
    });
  }
}

customElements.define('sticky-scroll', StickyScroll);
